
// XML gerado no processo principal via IPC (NfceXmlBuilderService)
import DanfeNfce from "../components/DanfeNfce.vue";

export default {
  name: "PdvNotasLocais",

  components: { DanfeNfce },

  data() {
    return {
      notas: [],
      carregando: true,
      filtro: {
        busca: "",
        statusFiscal: "",
        statusSync: "",
      },
      // uuid_venda_terminal → true enquanto gera
      gerandoXml: {},
      // uuid_venda_terminal → mensagem de erro
      erroXml: {},
      copiado: false,
      modalXml: {
        visivel: false,
        nota: null,
        conteudo: "",
      },
      modalErro: {
        visivel: false,
        nota: null,
        mensagem: "",
      },
      // Modal DANFE NFC-e
      modalDanfe: {
        visivel: false,
        uuid:    null,
      },
    };
  },

  computed: {
    notasFiltradas() {
      return this.notas.filter((n) => {
        const busca = (this.filtro.busca || "").toLowerCase();
        const matchBusca =
          !busca ||
          String(n.numeroNota || n.id).toLowerCase().includes(busca) ||
          (n.nomeCliente || "").toLowerCase().includes(busca) ||
          (n.chave || "").includes(busca);

        const matchFiscal =
          !this.filtro.statusFiscal ||
          n.status_fiscal === this.filtro.statusFiscal;

        const matchSync =
          !this.filtro.statusSync ||
          n.status_sync === this.filtro.statusSync;

        return matchBusca && matchFiscal && matchSync;
      });
    },
  },

  async mounted() {
    await this.carregar();
  },

  methods: {
    async carregar() {
      this.carregando = true;
      try {
        this.notas = (await this.$electron.nfce.getAll()) || [];
      } catch (err) {
        this.$toast.error("Erro ao carregar notas: " + (err.message || err));
      } finally {
        this.carregando = false;
      }
    },

    // ── Gerar XML ──────────────────────────────────────────────────────────

    async gerarXml(nota) {
      const uuid = nota.uuid_venda_terminal;
      if (!uuid) {
        this.$toast.error("Nota sem UUID — não é possível gerar XML.");
        return;
      }

      this.$set(this.gerandoXml, uuid, true);
      this.$set(this.erroXml,    uuid, null);

      try {
        const resultado = await this.$electron.nfce.gerarXml(uuid);
        this.$toast.success("XML gerado com sucesso!");

        // Atualiza a nota localmente sem recarregar tudo
        const idx = this.notas.findIndex(
          (n) => n.uuid_venda_terminal === uuid
        );
        if (idx !== -1) {
          this.$set(this.notas, idx, {
            ...this.notas[idx],
            status_fiscal: "xml_gerado",
            chave: resultado.chave,
            xml: resultado.xml,
          });
        } else {
          await this.carregar();
        }
      } catch (err) {
        const msg = err.message || String(err);
        this.$set(this.erroXml, uuid, msg);
        this.$toast.error("Falha ao gerar XML: " + msg);
      } finally {
        this.$set(this.gerandoXml, uuid, false);
      }
    },

    // ── Visualizar XML ─────────────────────────────────────────────────────

    verXml(nota) {
      const conteudo = nota.xml || "";
      this.modalXml.nota     = nota;
      this.modalXml.conteudo = conteudo || "(sem XML gerado)";
      this.modalXml.visivel  = true;
      this.copiado           = false;
    },

    copiarXml() {
      navigator.clipboard
        .writeText(this.modalXml.conteudo)
        .then(() => {
          this.copiado = true;
          setTimeout(() => { this.copiado = false; }, 2500);
        })
        .catch(() => this.$toast.error("Erro ao copiar para a área de transferência."));
    },

    // ── Modal de erro ──────────────────────────────────────────────────────

    verErroXml(nota) {
      this.modalErro.nota     = nota;
      this.modalErro.mensagem = this.erroXml[nota.uuid_venda_terminal] || "Erro desconhecido.";
      this.modalErro.visivel  = true;
    },

    // ── Formatadores ───────────────────────────────────────────────────────

    formatarData(dt) {
      if (!dt) return "—";
      try {
        return new Date(dt).toLocaleString("pt-BR", {
          day:    "2-digit",
          month:  "2-digit",
          year:   "numeric",
          hour:   "2-digit",
          minute: "2-digit",
        });
      } catch {
        return String(dt);
      }
    },

    formatarValor(v) {
      if (v == null) return "—";
      return Number(v).toLocaleString("pt-BR", {
        style:    "currency",
        currency: "BRL",
      });
    },

    // ── Badges ─────────────────────────────────────────────────────────────

    badgeFiscal(status) {
      const map = {
        pendente_xml: "badge-warning",
        xml_gerado:   "badge-info",
        transmitida:  "badge-primary",
        autorizada:   "badge-success",
        rejeitada:    "badge-danger",
        cancelada:    "badge-secondary",
      };
      return map[status] || "badge-light";
    },

    labelFiscal(status) {
      const map = {
        pendente_xml: "Pend. XML",
        xml_gerado:   "XML Gerado",
        transmitida:  "Transmitida",
        autorizada:   "Autorizada",
        rejeitada:    "Rejeitada",
        cancelada:    "Cancelada",
      };
      return map[status] || (status || "—");
    },
  },
};
